import { Link } from "react-router-dom";
import { BRAND } from "@/config/brand";

export function Logo({ light = false, size = "md", testId = "brand-logo" }) {
  const img = size === "lg" ? "h-11 w-11" : "h-9 w-9";
  return (
    <Link to="/ugc-go" data-testid={testId} className="group inline-flex items-center gap-2.5" aria-label={`${BRAND.name} — accueil`}>
      <span className={`${img} overflow-hidden rounded-xl ${light ? "bg-ivory ring-1 ring-gold/40" : "bg-ivory"}`}>
        <img src={BRAND.logoMark} alt="" className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />
      </span>
      <span className={`font-sans text-xl font-bold tracking-[0.14em] ${light ? "text-white" : "text-bx"}`}>
        UGC<span className={light ? "text-gold" : "text-bx-2"}> GO</span>
      </span>
    </Link>
  );
}
